import React from "react";
import GlobalStyle from "../../styles/GlobalStyle";
import {
  scaleVertical,
  scaleHorizontal,
  FontSizes,
  scaleModerate,
} from "../../styles/responsive";
import { V2ReportStyle } from "../../styles/V2ReportStyle";
import { PALLETTE } from "../../utils/theme";

const MultilineTextBox = ({
  label,
  icon,
  description,
}: {
  label: string;
  icon: React.ReactNode;
  description?: string;
}) => {
  return (
    <div style={{ ...V2ReportStyle.flexColumnCenter, gap: scaleVertical(5) }}>
      {/* Label Row */}
      <div style={{ ...V2ReportStyle.flexRowCenter, gap: scaleHorizontal(2) }}>
        {icon}
        <span style={{ ...GlobalStyle.blackBoldText, fontSize: "2rem" }}>
          {label}
        </span>
      </div>

      {/* Description Box */}
      <div
        style={{
          ...V2ReportStyle.card,
          backgroundColor: PALLETTE.background,
          padding: scaleModerate(8),
          minHeight: scaleVertical(30),
          width: "100%",
          boxSizing: "border-box", // Important for width: 100% with padding
        }}
      >
        <span
          style={{
            ...GlobalStyle.blackRegularText,
            fontSize: "1.7rem",
          }}
        >
          {description}
        </span>
      </div>
    </div>
  );
};

export default MultilineTextBox;
